import { useSWRHandler } from "./useSWRHandler"
import { useFollows } from "src/hooks"

export function useFollowHandler() {
  return useSWRHandler(useFollows)
}
